import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton } from '@mui/material';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import PlayerDialog from './PlayerDialog';
import ThinkSkillLogo from '../../assets/images/thinkskill.png';

const AiVideo = ({
  url,
  secondaryColor,
  width,
  height,
  open,
  setOpen,
}) => {

  const handleToggleVideo = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width,
          height,
          backgroundColor: 'white',
          border: '2px solid #aeaeae',
          overflow: 'hidden',
          borderRadius: '8px',
        }}
      >
        <img
          alt="Video Thumbnail"
          src={ThinkSkillLogo}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>

      <IconButton
        aria-label="Play Video"
        onClick={handleToggleVideo}
        sx={{
          width: 64,
          height: 64,
          position: 'absolute',
          bottom: '-8%',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: secondaryColor || 'secondary.main',
          borderRadius: '50%',
          boxShadow: '0px 0px 12px rgba(0,0,0,0.4)',
          '&:hover': {
            backgroundColor: secondaryColor || 'secondary.main',
            opacity: 0.9,
          },
        }}
      >
        <PlayArrowRoundedIcon sx={{ color: 'white', fontSize: 36 }} />
      </IconButton>

      <PlayerDialog
        open={open}
        onClose={() => setOpen(false)}
        videoPath={url}
      />
    </Box>
  );
};

AiVideo.propTypes = {
  url: PropTypes.string,
  secondaryColor: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

export default AiVideo;